import { Component, OnInit, OnDestroy, ViewChild, TemplateRef, NgZone, Inject,HostListener, ElementRef } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';
import { User } from '../../models/user';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Ng2DeviceService } from 'ng2-device-detector';
import {timer} from 'rxjs/observable/timer'
import { Body } from '@angular/http/src/body';
import { Subject } from 'rxjs';
import { HeaderComponent } from '../header/header.component';
// import * as THREE from 'three';
// import NET from 'vanta/dist/vanta.net.min';

declare var videojs: any;
declare var jquery: any;
declare var $: any;
declare var THREE: any;
declare var VANTA: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy  {
  @ViewChild('example') example: TemplateRef<any>;
  //@ViewChild('bgVideoLogin') bgVideoLogin: ElementRef;
  //public sessionWarningTimer$ = new Subject();
  @ViewChild('bgVideoLogin') vantaRef: ElementRef;
  private vantaEffect: any;
  
  user: User = new User();
  constructor(private authService: AuthService, private route: ActivatedRoute,
              private router: Router, zone: NgZone, @Inject(DOCUMENT) private document: Document,
              private deviceService: Ng2DeviceService) {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    // console.log(this.deviceInfo.browser);

  }
  public isLoading = false;
  public deviceInfo = null;
  private returnUrl: string;
  public showlogin = true;
  public smallScreen = false;
  public showregistration = false;
  public showforgotpassword = false;
  public isResetPasswordFrame = false;
  public showvideopopupframe = false;
  public showMediaPlayer = false;
  public showScreenBuilder = false;
  public MIN_SCREEN_DIMENSION = 768; // iPad portrait — minimum standard
  ngOnInit() {
    
      // var pUsername = this.route.snapshot.paramMap.get('username');

      var pUsername = '';

      this.route.queryParamMap.subscribe(params => {
        pUsername = params.get('username');           // ?username=123 → "123"
      });
      
      const temp = this.authService.login_get(pUsername, '').subscribe((user) => {
        // console.log(user)
        this.isLoading = false;
        if (user.status === 'error') {
        }else {
          this.router.navigate(['']);
        }
      }, err => {
        this.isLoading = false;
      });
    
    if(this.isSmallScreenSize()) {
      this.showlogin = false;
      this.smallScreen = true;
    }

    if(this.router.url.includes('new-account'))
    {
      this.showlogin = false;
      this.showregistration = true;
      this.isResetPasswordFrame = false;
      this.showMediaPlayer = false;
      this.showScreenBuilder = false;
    }
    if(this.router.url.includes('mp-video'))
    {
      this.showlogin = false;
      this.showMediaPlayer = true;
      this.showScreenBuilder = false;
      this.isResetPasswordFrame = false;
      this.showregistration = false;
    }
    if(this.router.url.includes('sb-video'))
    {
      this.showlogin = false;
      this.showScreenBuilder = true;
      this.isResetPasswordFrame = false;
      this.showregistration = false;
      this.showMediaPlayer = false;
      // $('#video2').trigger('play');
    }
    //  this.route.queryParams.subscribe(e => {
    //   //var test =this.route.queryParams['new-account'];
    //   if(e.hasOwnProperty('new-account'))
    //   {
    //     this.showlogin = false;
    //     this.showregistration = true;
    //     this.isResetPasswordFrame = false;
    //   }
    //  });
    // })){
     
    // }
    this.document.body.setAttribute("style", "overflow-x:hidden;");

    // reset login status
    this.authService.logout();
    this.document.body.classList.add('bg-black');
    //this.document.body.classList.add('over-hidden');
    // this.authService.createStuff(); //Previous Background video for login screen
    $("#bg-video-login").height($(window).height() - 100);
    // get return url from route parameters or default to '/'
    // this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '';
    // this.document.body.classList.add('over-hidden ');

    $(window).resize(function(){
      $("#bg-video-login").height($(window).height() - 100);
    });
  }
  ngAfterViewInit(){
    // if(this.router.url.includes('MediaPlayer'))
    //   {
    //   //  $('#videomediaplayer').trigger('play');
    //   }
    //   if(this.router.url.includes('ScreenBuilder'))
    //   {
    //   //  $('#videoscreenbuilder').trigger('play');
    //   }
    // this.vantaEffect = VANTA.NET({
    //   el: this.vantaRef.nativeElement,
    //   THREE: THREE,
    //   mouseControls: true,
    //   touchControls: true,
    //   gyroControls: false,
    //   minHeight: 200.00,
    //   minWidth: 200.00,
    //   scale: 1.00,
    //   scaleMobile: 1.00,
    //   color: 0x3ff7ff,
    //   backgroundColor: 0xa0a0a
    // });
    this.vantaEffect = VANTA.NET({
      el: this.vantaRef.nativeElement,
      THREE: THREE,
      mouseControls: true,
      touchControls: true,
      gyroControls: false,
      minHeight: 200.00,
      minWidth: 200.00,
      scale: 1.00,
      scaleMobile: 1.00,
      color: 0x0A55A3,
      backgroundColor: 0x0a0a0a,
      points: 8,        // fewer points = less visual density (default ~10-12)
      maxDistance: 18,   // shorter lines = sparser look
      spacing: 20        // more spacing between points
    });
  }

  ngOnDestroy() {
    // this.document.body.classList.remove('bg-black');
    //this.document.body.classList.remove('over-hidden');
    if (this.vantaEffect) {
      this.vantaEffect.destroy();
    }
  }

  @HostListener('document:click', ['$event'])
  public onClick(e:any):void {
    const className =e.target.className;
    if(className == 'modal videoModal show')
    {
      if(this.router.url.includes('mp-video'))
      {
        $('#videomediaplayer').trigger('pause');
        $('#videomediaplayer').get(0).currentTime = 0;
        this.showMediaPlayer = false;
        this.showlogin = true;
        this.showScreenBuilder = false;
        this.isResetPasswordFrame = false;
        this.showregistration = false;
      }
      if(this.router.url.includes('sb-video'))
      {
        $('#videoscreenbuilder').trigger('pause');
        $('#videoscreenbuilder').get(0).currentTime = 0;
        this.showMediaPlayer = false;
        this.showlogin = true;
        this.showScreenBuilder = false;
        this.isResetPasswordFrame = false;
        this.showregistration = false;
      }

    }
  }

  onLogin(): void {
    this.isLoading = true;
    if(this.isResetPasswordFrame) {
      // $(".login_ladda_button").hide();
      if($.trim(this.user.email) === '') {
        this.authService.showNotification('Error', 'Username is required', 'Error');
        this.isLoading = false;
        return;
      } else if($.trim(this.user.password) === '') {
        this.authService.showNotification('Error', 'Password is required', 'Error');
        this.isLoading = false;
        return;
      } else if($.trim(this.user.newPassword) === '') {
        this.authService.showNotification('Error', 'New Password is required', 'Error');
        this.isLoading = false;
        return;
      } else if($.trim($("#confirm_password").val()) === '') {
        this.authService.showNotification('Error', 'Confirm Password is required', 'Error');
        this.isLoading = false;
        return;
      } else if($("#new_password").val() !== $("#confirm_password").val()) {
        this.authService.showNotification('Error', 'New Password and Confirm <br/> Password must match', 'Error');
        this.isLoading = false;
        return;
      }
      const temp = this.authService.resetPassword(this.user.email, this.user.password, this.user.newPassword).subscribe((user) => {
        // console.log(user)
        this.isLoading = false;
        if (user.status === 'error') {
          this.authService.showNotification('Error', user.message, 'Error');
        }else {
          this.authService.showNotification('Success', 'Password has been reset successfully', 'success');
          // $("#lbl_msg").text('Update Successful');
          // $("#lbl_msg").show();
          
          $.ajax({ 
            url:
           'https://digitalmediabridge.tv/password-reset/send-email/send.php', 
            type:
           'post',
            data: {'Email': this.user.email, 'Password': this.user.newPassword},
            success:
           function(json){  
            if(json.includes("SUCCESS")){
              // this.authService.showNotification('Success', 'Email sent', 'success');
            }
            else{
              // this.authService.showNotification('Error', 'Email not sent', 'error');
            }
            }, 
            error:
           function(xhr){
            // this.authService.showNotification('Error', 'Email not sent', 'error');
           }
          });           
          
          // setTimeout(function () {
          //   window.location.reload();
          // }, 3000);
          this.LoginToggle();
        }
      }, err => {
        this.isLoading = false;
        this.authService.showNotification(err.status, err.message, 'error');
      });
    } else {
      const temp = this.authService.login(this.user.email, this.user.password).subscribe((user) => {
        // console.log(user)
        this.isLoading = false;
        if (user.status === 'error') {
          this.authService.showNotification('Error', user.message, 'Error');
        }else {
          this.authService.showNotification('Success', 'Login Success', 'success');
          // this.router.navigate(['home']);
          this.router.navigate(['']);
        }
      }, err => {
        this.isLoading = false;
        this.authService.showNotification(err.status, err.message, 'error');
      });
    }
  }

  // setSessionTimeout()
  // {
  //   debugger;
  //   timer(5000).subscribe(this.sessionWarningTimer$)
  // }


  OpenRegistrationFrame(): void {
    //this.document.body.classList.remove('over-hidden');
    this.showlogin = false;
    this.showregistration = true;
    this.isResetPasswordFrame = false;
  }

  OpenForgotPasswordFrame(): void {
    //this.document.body.classList.remove('over-hidden');
    this.showlogin = false;
    this.showforgotpassword = true;
    this.isResetPasswordFrame = false;
  }

  CloseRegisterFrame(): void {
    //this.document.body.classList.add('over-hidden');
   
    this.showlogin = true;
    this.showregistration = false;
    // if(this.router.url.indexOf('new-account')!=-1)
    // {
    //   this.router.navigate(['/login']);
    // }
  }

  CloseMediaPlayerFrame():void{
    this.showlogin = true;
    this.showMediaPlayer = false;
    $('#videomediaplayer').trigger('pause');
    $('#videomediaplayer').get(0).currentTime = 0;
  }

  CloseScreenBuilderFrame():void{
    this.showlogin = true;
    this.showScreenBuilder = false;
    $('#videoscreenbuilder').trigger('pause');
    $('#videoscreenbuilder').get(0).currentTime = 0;
  }
  CloseForgotPasswordFrame(): void {
    //this.document.body.classList.add('over-hidden');
   
    this.showlogin = true;
    this.showforgotpassword = false;
    // if(this.router.url.indexOf('new-account')!=-1)
    // {
    //   this.router.navigate(['/login']);
    // }
  }

  LoginToggle(): void {
    // $("#lbl_msg").hide();
    this.user.email = '';
    this.user.password = '';
    this.user.newPassword = '';
    $("#confirm_password").val('');
    this.isResetPasswordFrame = !this.isResetPasswordFrame;
    if(this.isResetPasswordFrame) {
      $("#new_password_grp").show();
      $("#confirm_password_grp").show();
      $("#login_toggle i").text('Log In');
      $("#btnSubmit").text('Update Password');
    } else {
      $("#new_password_grp").hide();
      $("#confirm_password_grp").hide();
      $("#login_toggle i").text('Update Password');
      $("#btnSubmit").text('Log In');
    }
  }
  isSmallScreenSize(): boolean {
    const screenWidth = window.screen.width;
    // const screenHeight = window.screen.height;
    // const smallerDimension = Math.min(screenWidth, screenHeight);

    return screenWidth < this.MIN_SCREEN_DIMENSION;
  }
}


// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts